import { render, staticRenderFns } from "./CardShipmentsComponent.vue?vue&type=template&id=c8fc07d0&scoped=true"
import script from "./CardShipmentsComponent.vue?vue&type=script&lang=js"
export * from "./CardShipmentsComponent.vue?vue&type=script&lang=js"
import style0 from "./CardShipmentsComponent.vue?vue&type=style&index=0&id=c8fc07d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fc07d0",
  null
  
)

export default component.exports